// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/OrdersPage/style.css
// module id = 1865
// module chunks = 0